import { Component } from '@angular/core';
import { FormFieldBase } from '../../core/form-field/form-field.component';

@Component({
  selector: 'fz-form-field-text',
  template: `
    <mat-form-field fullWidth>
      <mat-label>
        <ng-content select="mat-label"></ng-content>
      </mat-label>
      <input
        matInput
        [formControl]="control"
        [controlErrorAnchor]="anchorField"
        [placeholder]="placeholder"
        [readonly]="disabled"
        [required]="required"
        [mask]="mask"
      />
      <mat-hint>
        <ng-content select="mat-hint"></ng-content>
      </mat-hint>
      <!-- Field Error Handler -->
      <mat-error>
        <ng-template
          controlErrorAnchor
          #anchorField="controlErrorAnchor"
        ></ng-template>
      </mat-error>
    </mat-form-field>
  `,
  styles: [
    `
      mat-form-field {
        width: 100%;
      }
    `,
  ],
})
export class FormFieldTextComponent extends FormFieldBase {}
